
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { Candidate } from "@/types/candidate";
import { updateCandidate as updateCandidateOperation } from "@/utils/candidate/operations/updateCandidate";

export const useCandidateActions = (id: string | undefined): {
  handleDelete: () => Promise<void>;
  handleUpdateCandidate: (updatedData: Partial<Candidate>) => Promise<void>;
} => {
  const handleDelete = async () => {
    if (!id || !window.confirm("Are you sure you want to delete this candidate?")) return;
    
    try {
      
      // Delete the candidate
      const { error } = await supabase
        .from('candidates')
        .delete()
        .eq('id', id);
      
      if (error) throw error;
      
      toast({
        title: "Candidate deleted",
        description: "The candidate has been successfully deleted",
      });
      
      // Navigate back to candidates page
      window.location.href = '/candidates';
    } catch (error) {
      console.error("Error deleting candidate:", error);
      toast({
        title: "Error deleting candidate",
        description: "Could not delete the candidate",
        variant: "destructive",
      });
    }
  };

  const handleUpdateCandidate = async (updatedData: Partial<Candidate>) => {
    if (!id) return;

    try {
      // Use the updateCandidate function from operations which handles history logging
      const success = await updateCandidateOperation(id, updatedData);
      
      if (!success) {
        throw new Error("Failed to update candidate");
      }
    } catch (error) {
      console.error("Error in handleUpdateCandidate:", error);
      toast({
        title: "Error updating candidate",
        description: "Could not update candidate information",
        variant: "destructive",
      });
    }
  };

  return { handleDelete, handleUpdateCandidate };
};
